import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { ContentTechnicalPhotoItemType } from '@features/productPreview/sections/ProductDescription/typescript';
import { ISlide } from '@features/productPreview/typescript';
import LayoutUiState from '@features/layout/mobX/LayoutUiState';
export default class ProductPreviewUiState {
  selectedSlider?: ISlide;
  isOpenModal: boolean = false;
  selectedTechSlider?: ContentTechnicalPhotoItemType;
  productName: string = '';
  windowDimensions: {
    width: number;
    height: number;
  } = {
    width: 700,
    height: 1200
  };
  layoutState?: typeof LayoutUiState;
  constructor(layoutUiState: typeof LayoutUiState) {
    makeAutoObservable(this, {
      windowDimensions: observable.struct
    });
    if (global && global.window) {
      this.setWindowDimension();
      window.onresize = this.setWindowDimension;
      window.addEventListener('load', () => {
        this.setWindowDimension();
      });
    }
    runInAction(() => {
      this.layoutState = layoutUiState;
    });
  }
  private setWindowDimension = action(() => {
    this.windowDimensions = {
      width: this.getWidth(),
      height: this.getHeight()
    };
  });
  public setSelectedSlider = (slide: ISlide) => {
    this.selectedSlider = slide;
    this.isOpenModal = true;
  };
  public showSlider = (slide: ContentTechnicalPhotoItemType) => {
    this.selectedTechSlider = slide;
  };
  public hideSlider = () => {
    this.selectedSlider = undefined;
    this.selectedTechSlider = undefined;
    this.isOpenModal = false;
  };
  public setProductName = (name: string) => {
    this.productName = name;
  };
  private getWidth = () => global?.window?.innerWidth;
  private getHeight = () => global?.window?.innerHeight;
  public setModalStatus = () => {
    this.isOpenModal = !this.isOpenModal;
  };
}